/**
 * anything that relates to DOM
 */
export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    windowHeight: 0,
    /**
     * breakpoint constants
     */
    widthExtraSmall: 320,
    widthSmall: 640,
    widthTablet: 760,
    widthDesktop: 990,
    navBarHeight: 85
  },

  mutations: {
    SET_WINDOW_WIDTH (state, value) {
      state.windowWidth = value
    },
    SET_WINDOW_HEIGHT (state, value) {
      state.windowHeight = value
    },
    SET_NAVBAR_HEIGHT (state, value) {
      state.navBarHeight = value
    }
  },

  getters: {
    isExtraSmall: (state) => state.windowWidth <= state.widthExtraSmall,
    isSmall: (state) => state.windowWidth <= state.widthSmall,
    isTablet: (state) => state.windowWidth <= state.widthTablet,
    isDesktop: (state) => state.windowWidth > state.widthDesktop,
    navBarHeight: state => {
      return state.navBarHeight
    }
  }
}
